import React from "react";
import { CarouselComponent, Button } from "../../index";
import { useCurrentWidth } from "../../../assets/utils/hooks";
import "./index.scss";
import { Fragment } from "react";

export default function Hero({ data, useCarousel }) {
	const withCarousel = (elements) =>
		useCarousel ? (
			<CarouselComponent controls whiteControls>
				{elements}
			</CarouselComponent>
		) : (
			<Fragment>{elements}</Fragment>
		);

	const width = useCurrentWidth();

	return withCarousel(
		data?.map(({ imageSource, heading, descriptions }) => (
			<div
				key={heading}
				className={useCarousel ? "carousel-item item" : "hero-item"}
				style={{
					backgroundImage: `url(${
						width > 768 ? imageSource[0] : imageSource[1]
					})`,
					backgroundRepeat: "no-repeat",
				}}
			>
				<h1 className="bolder">{heading}</h1>

				{descriptions && (
					<>
						{descriptions.map((description) => (
							<p key={description}>{description}</p>
						))}

						<Button wide uppercase linkTo="/donate" noHover>
							Donate
						</Button>
					</>
				)}
			</div>
		))
	);
}
